import { render } from "./BranchButtons.vue?vue&type=template&id=3b1dcc7a&scoped=true"
import script from "./BranchButtons.vue?vue&type=script&lang=js"
export * from "./BranchButtons.vue?vue&type=script&lang=js"

import "./BranchButtons.vue?vue&type=style&index=0&id=3b1dcc7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1dcc7a"]])

export default __exports__